var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"days-selector",attrs:{"items":_setup.historyDaysList,"prepend-inner-icon":_setup.innerIcon,"menu-props":{ bottom: true, offsetY: true },"dense":"","outlined":"","hide-details":""},model:{value:(_setup.historyDays),callback:function ($$v) {_setup.historyDays=$$v},expression:"historyDays"}})
}
var staticRenderFns = []

export { render, staticRenderFns }